import {GiftShopConfig} from '@/store/Constraints';
import {GiftApi,CartApi} from '@/api/Api';
import {Axios,setAuthToken} from '@/api/Axios';

const GiftShopStore = {

  state:{
    cartCount:0,
    mainData:{},
    egiftCategoryList:[],
    cardCategoryList:[],
    selectedItem:null
  },
  getters:{
    [GiftShopConfig.CART_COUNT]: (state) => state.cartCount,

    [GiftShopConfig.GIFT_MAIN_DATA]: (state) => state.mainData,

    [GiftShopConfig.GIFT_EGIFT_ITEM_CATEGORY]: (state) => state.egiftCategoryList,

    [GiftShopConfig.GIFT_CARD_ITEM_CATEGORY]: (state) => state.cardCategoryList,

    [GiftShopConfig.GIFT_SELECTED_ITEM]: (state) => state.selectedItem,
    
  }
  ,mutations:{
    [GiftShopConfig.CART_COUNT]:(state,payload) =>{
      console.log('GiftShopStore.mutations.CART_COUNT ->',payload);
      state.cartCount = payload;
    },

    [GiftShopConfig.GIFT_MAIN_DATA]:(state,payload) =>{
      console.log(`GiftShopStore.mutations.GIFT_MAIN_DATA -> ${JSON.stringify(payload)}`);
      state.mainData = payload;
    },    
    [GiftShopConfig.GIFT_EGIFT_ITEM_CATEGORY]:(state,payload) =>{
      console.log(`GiftShopStore.mutations.GIFT_EGIFT_ITEM_CATEGORY -> ${JSON.stringify(payload)}`);
      state.egiftCategoryList = payload;
    },
    [GiftShopConfig.GIFT_CARD_ITEM_CATEGORY]:(state,payload) =>{
      console.log(`GiftShopStore.mutations.GIFT_CARD_ITEM_CATEGORY -> ${JSON.stringify(payload)}`);      
      state.cardCategoryList = payload;
    },
    [GiftShopConfig.GIFT_SELECTED_ITEM]:(state,payload) =>{
      console.log(`GiftShopStore.mutations.GIFT_SELECTED_ITEM -> ${JSON.stringify(payload)}`);      
      state.selectedItem = payload;
    },
    
  }
  ,actions:{
    [GiftShopConfig.GET_GIFT_MAIN_DATA_EVENT]:(store,payload) =>{
      console.log(`GiftShopStore.action.GET_GIFT_MAIN_DATA_EVENT -> ${JSON.stringify(payload)}`);      
      return new Promise(async(resolve,reject) => {

          Axios.get(GiftApi.GET_GIFT_MAIN,payload)
          .then(res => {
              // resolve(res)
              if(res.code == '0000'){                
                store.commit(GiftShopConfig.GIFT_MAIN_DATA,res.data)
                return resolve(res.data)
              }
              reject(res)
          })
          .catch(err => {
              reject(err)
          })
      }) 
    },
    [GiftShopConfig.GET_GIFT_EGIFT_ITEM_CATEGORY_EVENT]:(store,payload) =>{
      console.log(`GiftShopStore.action.GET_GIFT_EGIFT_ITEM_CATEGORY_EVENT -> ${JSON.stringify(payload)}`);      
      return new Promise(async(resolve,reject) => {

          Axios.get(GiftApi.GET_GIFT_EGIFT_ITEM_CATEGORY,payload)
          .then(res => {
              // resolve(res)
              if(res.code == '0000'){                
                store.commit(GiftShopConfig.GIFT_EGIFT_ITEM_CATEGORY,res.data.categoryList)
                return resolve(res.data.categoryList)
              }
              reject(res)
          })
          .catch(err => {
              reject(err)
          })
      }) 
    },

    [GiftShopConfig.GET_GIFT_CARD_ITEM_CATEGORY_EVENT]:(store,payload) =>{
      console.log(`GiftShopStore.action.GET_GIFT_CARD_ITEM_CATEGORY_EVENT -> ${JSON.stringify(payload)}`);      
      return new Promise(async(resolve,reject) => {

          Axios.get(GiftApi.GET_GIFT_CARD_ITEM_CATEGORY,payload)
          .then(res => {
              // resolve(res)
              if(res.code == '0000'){                
                store.commit(GiftShopConfig.GIFT_CARD_ITEM_CATEGORY,res.data.categoryList)
                return resolve(res.data.categoryList)
              }
              reject(res)
          })
          .catch(err => {
              reject(err)
          })
      }) 
    },

    [GiftShopConfig.GET_CART_COUNT_EVENT]:(store,payload) =>{
      console.log(`GiftShopStore.action[GET_CART_COUNT_EVENT] -> ${JSON.stringify(payload)}`); 
      Axios.get(CartApi.GET_CART_COUNT,payload)
      .then(res => {                
          if(res.code == "0000"){
              store.commit(GiftShopConfig.CART_COUNT,res.data.cnt);
          }
      })
      .catch(err => {                  
          console.error('GiftShopStore.action.GET_CART_COUNT_EVENT ->',err); 
          // this.showAlert(err);             
      })
  },
  }
}

export default GiftShopStore


// WEBPACK FOOTER //
// ./src/store/giftshop/GiftShopStore.js